// *********** Form Data ************

export const getFormInputs = (
  roles: {
    name: string;
    id: string;
    designation: string;
  }[]
) => [
  {
    inputType: "text",
    name: "email",
    prompt: "Email",
    placeholder: "Enter Email Address",
    rules: { required: true },
    isFullWidth: false,
    required: true,
  },

  {
    inputType: "selectInput",
    name: "role_id",
    prompt: "User type",
    options: roles,
    required: true,
    isFullWidth: false,
    returnId: true, // Ensure the component returns the ID value
  },
];

// *************  DRF admin Table Data *********
export const TableKeys = [
  "firstName",
  "lastName",
  "email",
  "phone",
  "role",
  "status",
];

export const TableHeaders = [
  "First Name",
  "Last Name",
  "Email",
  "Phone Number",
  "Role",
  "Status",
];

export const TableData = (users: any) => {
  return users.map((user: any) => ({
    id: user.id,
    firstName: { value: user.first_name, type: "string" },
    lastName: { value: user.last_name, type: "string" },
    email: { value: user.email, type: "string" },
    phone: { value: user.phone_number, type: "string" },
    role: { value: user.roles[0].title, type: "string" },
    status: { value: user.status, type: "string" },
  }));
};
